<!-- 页面头部 -->
<template>
  <div class="web_header">
    <div
      class="language"
      :style="style"
      @click="handleClickLang"
    >
      {{ language }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    style: {
      type: Object,
      default: () => ({})
    }
  },
  name: 'WebHeader',
  data() {
    return {
      language: ''
    }
  },

  watch: {
    list: {
      handler(value) {
        if (value.length > 0) {
          value.map(item => {
            if (item.type === 'default') {
              this.language = item.name
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },

  components: {},

  methods: {
    // 点击选择
    handleClickLang() {
      this.$emit('listenHandlePickLang')
    },

  },

  mounted() { },
}
</script>
<style lang="less" scoped>
.web_header {
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px;
  overflow: hidden;
  .language {
    float: right;
    line-height: 20px;
    font-size: 14px;
    margin-right: 10px;
    letter-spacing: 1px;
  }
}
</style>
